import {planTypes, trackingPlanTypes} from "@/common/constants";
import {get} from "lodash";

export default {
  key: planTypes['large_meeting'],
  data () {
    return {
      logo: require('@/assets/plans/large_meeting.svg'),
      title: this.$t('billing.large_meeting.title'),
      subtitle: '',
      capacityKey: 'capacity',
      planType: planTypes.LARGE_MEETING,
      description: this.$t('billing.large_meeting.desc'),
      totalLimitDesc: this.$t('billing.licences_limit_tips', ['Large Meeting', 'Zoom One']),
      configDescription: this.$t('billing.large_meeting.config_desc'),
      supportCapacity: [500, 1000],
      capacityUnitI18nKey: 'billing.participants',
    }
  },
  computed: {
    trackingPlanKey() {
      return get(trackingPlanTypes, get(planTypes, this.planType));
    },
  }
};
